import { _ } from "libs";

import React from "react";

export default function NoResults({ text = "No results" }: { text?: string }) {
	return <div className="noResults">{text}</div>;
}
